"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Toggle: ()=>Toggle_Toggle
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const switch_namespaceObject = require("@base-ui-components/react/switch");
const external_Toggle_variants_cjs_namespaceObject = require("./Toggle.variants.cjs");
const Toggle_Toggle = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function({ checked, disabled, name, required, size = '24', onToggle, emphasis = 'regular' }, ref) {
    const { root, slider, tapSpaceSlot } = (0, external_Toggle_variants_cjs_namespaceObject.toggleVariants)({
        size,
        emphasis
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(switch_namespaceObject.Switch.Root, {
        className: root(),
        checked: checked,
        disabled: disabled,
        inputRef: ref,
        name: name,
        required: required,
        onCheckedChange: onToggle,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: tapSpaceSlot()
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(switch_namespaceObject.Switch.Thumb, {
                className: slider()
            })
        ]
    });
});
exports.Toggle = __webpack_exports__.Toggle;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Toggle"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
